/* Tildas redesign product page (sections/tb-main-product.liquid).
   Only presentation: the picture gallery, the order summary (poster + frame = total), the total on
   the add-to-cart button and the free-shipping bar. Adding to cart, the frame bundle and variant
   switching stay with product-form.js, frame-addon.js and VariantSelects in global.js. */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || !isFinite(cents)) return '';
    format = format || '{{amount}} kr';
    function group(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  function decode(html) {
    var t = document.createElement('textarea');
    t.innerHTML = html;
    return t.value;
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-tb-gallery]');
    if (!gallery) return function () {};
    var slides = gallery.querySelectorAll('.tb-gallery__slide[data-media-id]');
    var thumbs = gallery.querySelectorAll('.tb-gallery__thumb');
    function show(id) {
      id = String(id);
      var found = false;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-media-id') === id;
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-media-id') === id;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
        }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-media-id')); });
    });
    return show;
  }

  function init(root) {
    if (root.dataset.tbBooted) return;
    root.dataset.tbBooted = '1';
    var sectionId = root.getAttribute('data-section');
    var moneyFormat = decode(root.getAttribute('data-money-format') || '');
    var cartTotal = parseInt(root.getAttribute('data-cart-total'), 10) || 0;
    var freeShip = parseInt(root.getAttribute('data-free-ship'), 10) || 0;
    var productTitle = root.getAttribute('data-product-title') || '';
    var showMedia = initGallery(root);

    var variantSelects = root.querySelector('variant-selects');
    var variants = [];
    try {
      var script = variantSelects && variantSelects.querySelector('script[type="application/json"]');
      if (script) variants = JSON.parse(script.textContent);
    } catch (e) { variants = []; }

    var form = document.getElementById('product-form-' + sectionId);
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = root.querySelector('.tb-qty .quantity__input');
    var addButton = document.getElementById('ProductSubmitButton-' + sectionId);

    var summary = root.querySelector('[data-tb-summary]');
    var ship = root.querySelector('[data-tb-ship]');

    function currentVariant() {
      var id = idInput && idInput.value;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function basePrice() {
      var v = currentVariant();
      if (v) return v.price;
      // single-variant products have no variant picker (and no variant list): use the rendered price
      var fallback = parseInt(root.getAttribute('data-price'), 10);
      return isFinite(fallback) ? fallback : null;
    }
    function quantity() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return q > 0 ? q : 1;
    }
    function frameSelection() {
      return window.TBPFrame && typeof window.TBPFrame.getSelection === 'function' ? window.TBPFrame.getSelection() : null;
    }

    function totalSpan() {
      if (!addButton) return null;
      var span = addButton.querySelector('[data-tb-total]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-tb-total', '');
        span.className = 'tb-buy__total';
        var label = addButton.querySelector(':scope > span');
        if (label && label.nextSibling) addButton.insertBefore(span, label.nextSibling);
        else addButton.appendChild(span);
      }
      return span;
    }

    // Each size button shows the price of that size with the other choices as they are now
    // (people, colour, duo/trio), so it follows those choices instead of the page-load ones.
    function updateSizePrices(v) {
      if (!v || !v.options) return;
      root.querySelectorAll("[data-tb-size-price]").forEach(function (el) {
        var want = v.options.slice();
        want[parseInt(el.getAttribute("data-pos"), 10) - 1] = el.getAttribute("data-value");
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          if (o.length === want.length && o.every(function (x, k) { return x === want[k]; })) {
            el.textContent = formatMoney(variants[i].price, moneyFormat);
            return;
          }
        }
      });
    }

    function update() {
      var v = currentVariant();
      updateSizePrices(v);
      var price = basePrice();
      var qty = quantity();
      var frame = frameSelection();
      var frameCents = frame && typeof frame.price === 'number' ? frame.price : 0;
      var total = price != null ? (price + frameCents) * qty : null;

      if (summary) {
        var hasPicker = !!root.querySelector('[data-frame-picker]');
        summary.hidden = !hasPicker || price == null;
        if (hasPicker && price != null) {
          var sizeLabel = v ? v.title : '';
          summary.querySelector('[data-tb-summary-poster]').textContent = (qty > 1 ? qty + ' × ' : '') + (sizeLabel && sizeLabel !== 'Default Title' ? sizeLabel : productTitle);
          summary.querySelector('[data-tb-summary-poster-price]').textContent = formatMoney(price * qty, moneyFormat);
          var frameRow = summary.querySelector('[data-tb-summary-frame-row]');
          frameRow.hidden = !frame;
          if (frame) {
            summary.querySelector('[data-tb-summary-frame]').textContent = (qty > 1 ? qty + ' × ' : '') + frame.colorLabel + (frame.size ? ', ' + frame.size : '');
            summary.querySelector('[data-tb-summary-frame-price]').textContent = formatMoney(frameCents * qty, moneyFormat);
          }
          summary.querySelector('[data-tb-summary-total]').textContent = formatMoney(total, moneyFormat);
        }
      }

      var span = totalSpan();
      if (span) {
        var disabled = addButton.hasAttribute('disabled');
        span.textContent = !disabled && total != null ? ' · ' + formatMoney(total, moneyFormat) : '';
      }

      if (ship && freeShip > 0) {
        var msg = ship.querySelector('[data-tb-ship-msg]');
        var fill = ship.querySelector('[data-tb-ship-fill]');
        var sum = cartTotal + (total || 0);
        var left = Math.max(0, freeShip - sum);
        msg.textContent = left > 0
          ? msg.getAttribute('data-left').replace('{{ amount }}', formatMoney(left, moneyFormat)).replace('{{amount}}', formatMoney(left, moneyFormat))
          : msg.getAttribute('data-done');
        fill.style.width = Math.min(100, Math.round((sum / freeShip) * 100)) + '%';
      }
    }

    if (idInput) idInput.addEventListener('change', function () {
      var v = currentVariant();
      if (v && v.featured_media && !root.hasAttribute('data-no-variant-media')) showMedia(v.featured_media.id);
      // VariantSelects re-enables the button and rewrites its label after fetching the section
      setTimeout(update, 0);
    });
    if (qtyInput) qtyInput.addEventListener('change', update);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId === sectionId) update();
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { cartTotal = cart.total_price || 0; update(); })
          .catch(function () {});
      });
    }
    function hookFrame() {
      if (window.TBPFrame && typeof window.TBPFrame.onChange === 'function' && !root.dataset.tbFrameHooked) {
        root.dataset.tbFrameHooked = '1';
        window.TBPFrame.onChange(update);
      }
      update();
    }
    hookFrame();
    window.addEventListener('load', hookFrame, { once: true });
  }

  function initNameCounters(root) {
    root.querySelectorAll('[data-tb-name-field]').forEach(function (field) {
      var input = field.querySelector('input');
      var count = field.querySelector('[data-tb-count]');
      if (!input || !count) return;
      var sync = function () { count.textContent = input.value.length; };
      input.addEventListener('input', sync);
      sync();
    });
  }

  // Wall colours for the knitted-name example: a row of swatches that only changes the example's
  // background, so the customer can see the yarn against their own wall. Not sent with the order.
  // white, off-white, beige, greige, light grey, sage, dusty pink; any other colour via the picker
  var TB_WALLS = ['#FFFFFF', '#F4F0E8', '#E6D9C3', '#D3CBBF', '#DCDCDA', '#C5CDB8', '#E6D1CA'];
  function addWalls(root, previewBox, noteText) {
    if (!previewBox || previewBox.querySelector('.tb-yarn__walls')) return;
    var names = (root.getAttribute('data-wall-names') || '').split(',');
    var note = document.createElement('p');
    note.className = 'tb-t-small tb-yarn__note';
    note.textContent = noteText || root.getAttribute('data-yarn-note') || '';
    if (note.textContent) previewBox.appendChild(note);
    var row = document.createElement('div');
    row.className = 'tb-yarn__walls';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', root.getAttribute('data-wall-label') || '');
    var label = document.createElement('span');
    label.className = 'tb-t-label tb-muted';
    label.textContent = root.getAttribute('data-wall-label') || '';
    row.appendChild(label);
    TB_WALLS.forEach(function (hex, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tb-yarn__wall';
      b.style.background = hex;
      b.setAttribute('aria-label', names[i] || hex);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        row.querySelectorAll('.tb-yarn__wall').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        previewBox.style.background = hex;
        setDark(hex);
        custom.removeAttribute('data-on');
      });
      row.appendChild(b);
    });
    // free colour: the browser's colour picker behind a rainbow swatch
    var custom = document.createElement('label');
    custom.className = 'tb-yarn__custom';
    var dot = document.createElement('span');
    dot.className = 'tb-yarn__custom-dot';
    dot.setAttribute('aria-hidden', 'true');
    var txt = document.createElement('span');
    txt.textContent = root.getAttribute('data-wall-custom') || '';
    custom.appendChild(dot);
    custom.appendChild(txt);
    var picker = document.createElement('input');
    picker.type = 'color';
    picker.value = '#D3CBBF';
    picker.setAttribute('aria-label', root.getAttribute('data-wall-custom') || '');
    custom.appendChild(picker);
    picker.addEventListener('input', function () {
      row.querySelectorAll('button.tb-yarn__wall').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      custom.setAttribute('data-on', '');
      dot.style.background = picker.value;
      previewBox.style.background = picker.value;
      setDark(picker.value);
    });
    row.appendChild(custom);
    function setDark(hex) {
      var n = parseInt(hex.replace('#', ''), 16);
      var lum = (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
      previewBox.classList.toggle('tb-yarn__preview--dark', lum < 0.45);
    }
    previewBox.appendChild(row);
    previewBox.style.background = TB_WALLS[0];
  }

  // Yarn colour picker (snippets/tb-yarn-picker.liquid): a sequence of colours written into one line
  // item property. Each tap on a swatch adds that colour (the same colour may come back), the chosen
  // colours line up in order and a tap on one takes it out. With a name on the page there is one colour
  // per letter and the example word shows them letter by letter; otherwise up to data-max colours.
  // Adding to cart without a colour shows a message instead.
  function initYarn(root) {
    root.querySelectorAll('[data-tb-yarn]').forEach(function (box) {
      if (box.dataset.tbBooted) return;
      box.dataset.tbBooted = '1';
      var fixedMax = parseInt(box.getAttribute('data-max'), 10) || 4;
      var max = fixedMax;
      var nameInput = root.querySelector('[data-tb-name-field] input, input[name="properties[Name]"]');
      var preview = box.querySelector('[data-tb-yarn-preview]');
      var word = box.querySelector('[data-tb-yarn-word]');
      var seqEl = box.querySelector('[data-tb-yarn-seq]');
      var example = box.getAttribute('data-example') || '';
      var flowers = box.hasAttribute('data-flowers');
      var flowerUid = 'tbf' + Math.random().toString(36).slice(2, 8);
      var removeLabel = box.getAttribute('data-remove') || '';
      function letters() { return nameInput ? (nameInput.value.match(/\p{L}/gu) || []).length : 0; }
      var input = box.querySelector('[data-tb-yarn-value]');
      var summary = box.querySelector('[data-tb-yarn-summary]');
      var hint = summary ? summary.textContent : '';
      var error = box.querySelector('[data-tb-yarn-error]');
      var buttons = box.querySelectorAll('[data-yarn]');
      var order = []; // the chosen swatch buttons, in letter order, repeats allowed

      function drawWord() {
        if (!word) return;
        var text = (nameInput && nameInput.value.trim()) || example;
        word.textContent = '';
        var k = 0;
        Array.from(text).forEach(function (ch) {
          var span = document.createElement('span');
          span.textContent = ch;
          if (/\p{L}/u.test(ch)) {
            span.className = 'tb-yarn__letter';
            if (order.length) span.style.backgroundImage = 'url("' + order[k % order.length].getAttribute('data-img') + '")';
            k++;
          }
          word.appendChild(span);
        });
      }
      // Knitted flowers: three six-petal cord loops (traced from the product photo), flower i in colour i
      // (colours repeat when fewer are chosen, plain grey cord before any). A big flower is 15 cm, a small 10 cm;
      // "2 små 1 stor" makes the last one big. The cord keeps its thickness whatever the flower size.
      function flowerSizes() {
        var big = false;
        root.querySelectorAll('.tb-opt input:checked, select option:checked').forEach(function (el) {
          if (/stor|big|large|gro(ß|ss)/i.test(el.value || el.textContent || '')) big = true;
        });
        return big ? [1, 1, 1.5] : [1, 1, 1];
      }
      function petalPath(r) {
        var p = function (x, y) { return (x * r).toFixed(1) + ',' + (y * r).toFixed(1); };
        return 'M0,0 C' + p(-0.2, -0.16) + ' ' + p(-0.46, -0.9) + ' ' + p(0, -1) + ' C' + p(0.46, -0.9) + ' ' + p(0.2, -0.16) + ' 0,0Z';
      }
      function drawFlowers() {
        if (!word) return;
        var sizes = flowerSizes();
        var R = 36, cord = 5.5, gap = 18, pad = cord;
        var x = pad, h = 0, parts = [], defs = [];
        sizes.forEach(function (s, i) {
          var r = R * s, cx = x + r, btn = order.length ? order[i % order.length] : null;
          var paint = '#CFC8BD';
          if (btn) {
            var id = flowerUid + i;
            defs.push('<pattern id="' + id + '" patternUnits="userSpaceOnUse" width="22" height="22"><image href="' + btn.getAttribute('data-img') + '" width="22" height="22" preserveAspectRatio="xMidYMid slice"/></pattern>');
            paint = 'url(#' + id + ')';
          }
          var d = petalPath(r), petals = '';
          for (var k = 0; k < 6; k++) petals += '<path d="' + d + '" transform="rotate(' + (k * 60) + ')"/>';
          parts.push({ cx: cx, r: r, g: '<g fill="none" stroke="' + paint + '" stroke-width="' + cord + '" stroke-linejoin="round">' + petals + '</g>' });
          x = cx + r + gap;
          h = Math.max(h, 2 * r);
        });
        var W = x - gap + pad, H = h + 2 * pad;
        var svg = '<svg class="tb-yarn__flowers" viewBox="0 0 ' + W.toFixed(0) + ' ' + H.toFixed(0) + '" aria-hidden="true"><defs>' + defs.join('') + '</defs>';
        parts.forEach(function (f) { svg += '<g transform="translate(' + f.cx.toFixed(1) + ',' + (pad + h - f.r).toFixed(1) + ')">' + f.g + '</g>'; });
        word.innerHTML = svg + '</svg>';
      }
      function drawSeq() {
        if (!seqEl) return;
        seqEl.textContent = '';
        seqEl.hidden = order.length === 0;
        order.forEach(function (btn, i) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'tb-yarn__chip';
          chip.setAttribute('aria-label', removeLabel.replace('__NAME__', btn.getAttribute('data-yarn')));
          chip.innerHTML = '<span class="tb-yarn__chip-n">' + (i + 1) + '</span><span class="tb-yarn__chip-sw" style="background-image:url(&quot;' + btn.getAttribute('data-img') + '&quot;)"></span><span class="tb-yarn__chip-x" aria-hidden="true">×</span>';
          chip.addEventListener('click', function () { order.splice(i, 1); sync(); });
          seqEl.appendChild(chip);
        });
      }
      function sync() {
        if (nameInput) {
          var n = letters();
          max = n > 0 ? n : 9;
          hint = n > 0 ? box.getAttribute('data-hint-letters').replace('__MAX__', n) : box.getAttribute('data-hint-letter');
        }
        // a shorter name drops the colours picked last
        if (order.length > max) order = order.slice(0, max);
        var list = order.map(function (btn) { return btn.getAttribute('data-yarn'); });
        input.value = list.join(', ');
        if (summary) summary.textContent = list.length ? list.join(', ') : hint;
        if (flowers) drawFlowers(); else drawWord();
        drawSeq();
        var full = order.length >= max;
        buttons.forEach(function (btn) {
          var used = order.indexOf(btn) !== -1;
          btn.setAttribute('aria-pressed', used ? 'true' : 'false');
          btn.disabled = full;
        });
        if (list.length && error) error.hidden = true;
      }
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (order.length >= max) return;
          order.push(btn);
          sync();
        });
      });
      if (flowers && preview) {
        preview.hidden = false;
        addWalls(root, preview, root.getAttribute('data-yarn-note-flowers'));
        // the flower option (three small / two small and one big) changes the example
        root.addEventListener('change', function () { drawFlowers(); });
      } else if (nameInput) {
        if (preview) { preview.hidden = false; addWalls(root, preview); }
        nameInput.addEventListener('input', sync);
      }
      var form = input.form || document.getElementById(input.getAttribute('form'));
      if (form) {
        form.addEventListener('submit', function (e) {
          if (input.value) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (error) error.hidden = false;
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      }
      sync();
    });
  }

  // Knitted name with a yarn colour option (stickat-namn): an example word under the name field, filled
  // with the selected yarn (the swatch picture of the checked colour), following the name as it is typed.
  function initKnitPreview(root) {
    if (root.dataset.tbKnitPreview || root.querySelector('[data-tb-yarn]')) return;
    var yarnOpt = root.querySelector('.tb-opt--yarn');
    var nameInput = root.querySelector('[data-tb-name-field] input, input[name="properties[Name]"]');
    if (!yarnOpt || !nameInput) return;
    root.dataset.tbKnitPreview = '1';
    var box = document.createElement('div');
    box.className = 'tb-yarn__preview';
    var label = document.createElement('span');
    label.className = 'tb-t-label tb-muted';
    label.textContent = root.getAttribute('data-yarn-example-label') || '';
    var word = document.createElement('p');
    word.className = 'tb-yarn__word';
    word.setAttribute('aria-hidden', 'true');
    box.appendChild(label);
    box.appendChild(word);
    var field = nameInput.closest('[data-tb-name-field], .product-form__input') || nameInput.parentElement;
    field.insertAdjacentElement('afterend', box);
    addWalls(root, box);
    function img() {
      var checked = yarnOpt.querySelector('input:checked');
      var lbl = checked && root.querySelector('label[for="' + checked.id + '"]');
      var fill = lbl && lbl.querySelector('.tb-swatch__fill');
      var m = fill && (fill.getAttribute('style') || '').match(/url\(['"]?([^'")]+)['"]?\)/);
      return m ? m[1] : '';
    }
    function draw() {
      var text = nameInput.value.trim() || root.getAttribute('data-yarn-example-name') || '';
      var url = img();
      word.textContent = '';
      Array.from(text).forEach(function (ch) {
        var span = document.createElement('span');
        span.textContent = ch;
        if (/\p{L}/u.test(ch)) {
          span.className = 'tb-yarn__letter';
          if (url) span.style.backgroundImage = 'url("' + url + '")';
        }
        word.appendChild(span);
      });
    }
    nameInput.addEventListener('input', draw);
    yarnOpt.addEventListener('change', draw);
    draw();
  }

  function boot() {
    document.querySelectorAll('[data-tb-product]').forEach(function (root) {
      initNameCounters(root);
      initYarn(root);
      initKnitPreview(root);
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
